import React from 'react'
import SideNav from './SideNav'

const Gallery = () => {
  return (
    <div>
      <>
        <div className="page-header parallaxie">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-header-box">
                  <h1 className="text-anime-style-2" data-cursor="-opaque">
                    Our Gallery
                  </h1>
                  <div className="hero-btn wow fadeInUp" data-wow-delay="0.4s">
                    <a href="about-us" className="btn-default">About Us</a>
                    <a href="contact-us" className="btn-default btn-highlighted">Contact Us</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-service-single">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="service-single-content">

                  <div className="service-entry">
                    <p className="wow fadeInUp">
                      Explore a visual journey through our design portfolio — homes, offices, 
                      and outdoor spaces that capture the heart of what <b>MeHome</b> stands for: 
                      creativity, quality, and craftsmanship. Each project is unique, 
                      yet every space shares one thing — it’s made with passion.
                    </p>

                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Our <span>Featured Works</span>
                    </h2>
                    <p className="wow fadeInUp" data-wow-delay="0.2s">
                      From interior design to turnkey construction, each image below 
                      showcases a story of design excellence and attention to detail.
                    </p>
                  </div>

                  <div className="service-gallery wow fadeInUp" data-wow-delay="0.6s">
                    <div className="row g-3">

                      <div className="col-md-4 col-sm-6">
                        <img src="/images/gallery1.jpg" alt="Luxury Living Room" className="img-fluid rounded-3 shadow-sm" />
                      </div>

                      <div className="col-md-4 col-sm-6">
                        <img src="/images/gallery2.jpg" alt="Modern Kitchen Design" className="img-fluid rounded-3 shadow-sm" />
                      </div>

                      <div className="col-md-4 col-sm-6">
                        <img src="/images/gallery3.jpg" alt="Elegant Bedroom Interior" className="img-fluid rounded-3 shadow-sm" />
                      </div>

                      <div className="col-md-4 col-sm-6">
                        <img src="/images/gallery4.jpg" alt="Dining Area Design" className="img-fluid rounded-3 shadow-sm" />
                      </div>

                      <div className="col-md-4 col-sm-6">
                        <img src="/images/gallery5.jpg" alt="Outdoor Garden Space" className="img-fluid rounded-3 shadow-sm" />
                      </div>

                      <div className="col-md-4 col-sm-6">
                        <img src="/images/gallery6.jpg" alt="Office Interior Project" className="img-fluid rounded-3 shadow-sm" />
                      </div>

                      <div className="col-md-4 col-sm-6">
                        <img src="/images/gallery7.jpg" alt="Custom Furniture Design" className="img-fluid rounded-3 shadow-sm" />
                      </div>

                      <div className="col-md-4 col-sm-6">
                        <img src="/images/gallery8.jpg" alt="Bathroom and Vanity Design" className="img-fluid rounded-3 shadow-sm" />
                      </div>

                      <div className="col-md-4 col-sm-6">
                        <img src="/images/gallery9.jpg" alt="Kids Room Concept" className="img-fluid rounded-3 shadow-sm" />
                      </div>

                    </div>
                  </div>

                  <div className="section-title mt-5">
                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Capturing <span>Our Passion for Design</span>
                    </h2>
                  </div>

                  <p className="wow fadeInUp" data-wow-delay="0.4s">
                    Every MeHome project is a collaboration — between imagination and execution, 
                    between the client’s vision and our expertise. Our gallery reflects years of dedication, 
                    design mastery, and the joy of crafting homes that truly feel alive.
                  </p>

                  <div className="row g-3 mt-3">
                    <div className="col-md-6">
                      <img src="/images/gallery10.jpg" alt="Luxury Villa Interior" className="img-fluid rounded-3 shadow-sm" />
                    </div>
                    <div className="col-md-6">
                      <img src="/images/gallery11.jpg" alt="Compact Apartment Design" className="img-fluid rounded-3 shadow-sm" />
                    </div>
                  </div>

                  <p className="wow fadeInUp mt-4" data-wow-delay="0.6s">
                    From minimal modern interiors to rich classical designs, our portfolio covers 
                    a range of styles and scales — each handled with the same precision, creativity, and care.
                  </p>

                </div>
              </div>

              <div className="col-lg-4">
                <SideNav />
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  )
}

export default Gallery
